import React, { useEffect, useState } from 'react'
import { Row, Col, Panel, FlexboxGrid } from 'rsuite'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import { doneLoading, startLoading } from '../../../utils/loading'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { downloadSubprojectFile } from '../../../redux/actions/subProject'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import notification from '../../../utils/notification'
import SubProjectAddressView from '../../subProject/address/SubProjectAddressView'
import moment from 'moment'
import { DD_MM_YYYY_SLASH, REQUEST_DATE_FORMAT } from '../../../constants/date'
import { maskIdCard } from '../../../utils/dataUtil'
import HTMLWidget from '../../HTMLWidget'

export default function ViewFormWidget({ schema, objectDatas, style = { marginBottom: -20 } }) {
  const emptyValue = <>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</>

  const [objects, setObjects] = useState([])

  useEffect(() => {
    if (!objectDatas) {
      setObjectsData(schema?.objects)
    }
  }, [schema])

  useEffect(() => {
    if (objectDatas) {
      setObjectsData(objectDatas)
    }
  }, [objectDatas])

  const setObjectsData = (objects) => {
    if (objects) {
      let uniqueViewGoups = objects.reduce((acc, obj) => {
        if (!acc.includes(obj['viewGoup'])) {
          acc.push(obj['viewGoup'])
        }
        return acc
      }, [])

      let datas = []

      uniqueViewGoups?.forEach((e) => {
        datas.push(objects.filter((item) => item.viewGoup == e))
      })
      // console.log('uniqueViewGoups : ', uniqueViewGoups)
      // console.log('datas : ', datas)

      setObjects(datas)
    }
  }

  const onDownload = async (path, name) => {
    startLoading()
    try {
      var file = await downloadSubprojectFile(path)

      downloadFile(file, name)
    } catch (e) {
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
  }

  const onPreview = async (path, name) => {
    startLoading()
    try {
      var file = await downloadSubprojectFile(path)

      previewFile(file, name)
    } catch (e) {
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }

    doneLoading()
  }

  const setAlertMessage = (type, message) => {
    notification.open(type, {
      title: message,
      duration: 2500,
    })
  }

  return (
    <Panel style={style}>
      {objects.map((item) => {
        return (
          <FlexboxGrid>
            {item.map((subItem) => {
              var viewData

              if (subItem.type == 'SINGLE_UPLOAD') {
                viewData = (
                  <div style={{ marginTop: 10 }}>
                    <ViewButton
                      style={{
                        marginRight: 10,
                        marginLeft: 10,
                        marginBottom: 10,
                      }}
                      disabled={!subItem.value}
                      onClick={() => {
                        var fileNames = subItem.value.split('/')
                        onPreview(subItem.value, fileNames?.pop() || 'preview')
                      }}
                    />
                    <DownloadButton
                      disabled={!subItem.value}
                      onClick={() => {
                        var fileNames = subItem.value.split('/')
                        onDownload(subItem.value, fileNames?.pop() || 'download')
                      }}
                    />
                  </div>
                )
              } else if (
                subItem.type == 'RADIO' ||
                subItem.type == 'DOPDOWN' ||
                subItem.type == 'lOCATION_CASCADER'
              ) {
                viewData = (
                  <>{subItem.valueDef ? <b>{subItem.valueDef} </b> : <u>{emptyValue}</u>}</>
                )
              } else if (subItem.type == 'ADDRESS') {
                viewData = (
                  <>
                    {subItem.subSchemas?.map((e) => {
                      return <SubProjectAddressView schema={e} bordered />
                    })}
                  </>
                )
              } else if (subItem.type == 'DATE') {
                viewData = (
                  <>
                    {subItem.value ? (
                      <b>{moment(subItem.value, REQUEST_DATE_FORMAT).format(DD_MM_YYYY_SLASH)} </b>
                    ) : (
                      <u>{emptyValue}</u>
                    )}
                  </>
                )
              } else if (subItem.type == 'EDITOR') {
                viewData = (
                  <>
                    {subItem.value ? (
                      <div style={{ marginLeft: 20 }}>
                        <HTMLWidget data={subItem.value} />
                      </div>
                    ) : (
                      <u>{emptyValue}</u>
                    )}
                  </>
                )
              } else if (subItem.type == 'DATA') {
                viewData = (
                  <div style={{ marginTop: 20, marginBottom: 10 }}>
                    <HTMLWidget data={subItem.value} />
                  </div>
                )
              } else if (subItem.type == 'MSG') {
                viewData = <></>
              } else {
                viewData = (
                  <>
                    {subItem.value ? (
                      <b>{subItem.isTaxId ? maskIdCard(subItem.value) : subItem.value} </b>
                    ) : (
                      <u>{emptyValue}</u>
                    )}
                  </>
                )
              }

              return (
                <FlexboxGrid.Item
                  componentClass={Col}
                  colspan={24}
                  xs={24}
                  sm={24}
                  md={subItem.sizeMdLg || 24}
                  lg={subItem.sizeMdLg || 24}
                  style={{ marginTop: subItem.type == 'HEADER_LABEL' ? 20 : 10 }}
                >
                  {subItem.label && (
                    <>
                      {subItem.isBolder || subItem.type == 'HEADER_LABEL' ? (
                        <strong>{subItem.label || ''}</strong>
                      ) : (
                        <span>{subItem.label || ''}</span>
                      )}{' '}
                      :{' '}
                    </>
                  )}

                  {subItem.type != 'HEADER_LABEL' && (viewData || '')}
                </FlexboxGrid.Item>
              )
            })}
          </FlexboxGrid>
        )
      })}
    </Panel>
  )
}
